import * as React from 'react';
import StandardLayout from '../../layouts/StandardLayout';

const ForgotPasswordConfirmationPage = () => {
    return (
        <StandardLayout>
            <div
                className="content container col col-md-8 col-lg-6 col-xl-4"
            >
                <h2>Password Reset Link Sent</h2>
                <p>Please check your email to reset your password</p>
            </div>
        </StandardLayout>
    );
};

export default ForgotPasswordConfirmationPage;


// WEBPACK FOOTER //
// ./src/components/pages/auth/ForgotPasswordConfirmationPage.tsx